exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-6d3e7b32]{font-family:Lato,Helvetica Neue,Arial,Helvetica,sans-serif}.list[data-v-6d3e7b32]{display:flex;flex-direction:row;justify-content:space-evenly;align-items:stretch;flex-wrap:wrap;gap:50px 50px;padding:28px 2em 7em;margin-bottom:-6em;background:#fff linear-gradient(90deg,#3f51b5,#64b5f6) repeat scroll}.statistics[data-v-6d3e7b32]{display:inline-flex;margin:10px;padding:10px}.label[data-v-6d3e7b32],.statistics[data-v-6d3e7b32],.value[data-v-6d3e7b32]{text-align:center;color:#fff;font-size:1.1em;font-weight:500}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6d3e7b32","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home/CvStatsList.vue
// module id = 318
// module chunks = 0